import { FETCH_ALL_EQUIPE_TURMA,
         FETCH_ALL_EQUIPE_POSTS,
         FETCH_ALL_COMENTARIOS_POSTS_EQUIPE,
         FETCH_ALL_ALUNOS_EQUIPE,
         FETH_ALL_PROFESSOR_EQUIPE,
         FETH_ALL_PROFESSOR_TURMA_DISCIPLLINA,
         FETH_ALL_EQUIPES_ATIVAS_INATIVAS_PROFESSOR,
         ADD_LIKE_POST_EQUIPE,
         REMOVER_POST_EQUIPE,
         ADD_POST_EQUIPE,
         FETH_COMENTATIO_POST_EQUIPE,
         ADD_POST_COMENTARIO_EQUIPE,
         REMOVER_COMENTARIO_POST_EQUIPE,
         REMOVER_EQUIPE,
         REMOVER_ALUNO_EQUIPE,
         FETCH_ALL_DISCIPLINA_PROFESSOR,
         ADD_EQUIPE,
         UPDATE_EQUIPE,
         FETCH_ALL_TURMA_DISCIPLINA,
         FETCH_ALL_EQUIPES_ALUNOS,
         FETCH_ALL_ALUNOS_ADICIONAR_EQUIPE,
         DESATIVAR_EQUIPES} from '../actions/grupoAction';

const INITIAL_STATE = { 
                        all_equipe_turma                     : [],
                        fetch_tur_dis                        : {},
                        all_aluno_equipe                     : [],
                        all_equipe_professor                 : [],
                        all_comentarios_posts_equipe         : [],
                        all_fatch_professor_turma_disciplina : [],
                        all_equipes_ativas_professor : [],
                        all_equipes_inativas_professor : [],
                        all_equipe_posts                     : [],
                        alunos                               : [],
                        dados_turma                          : [],
                        nome_turma                           : null,
                        nome_equipe                          : null,
                        curso                                : null,
                        turma                                : null,
                        nome_disciplina                      : null,
                        disciplina_equipe                    : null,
                        all_aluno_adicionar_equipe           : [],
                        all_disciplina_turma_professor       : [],
                        all_equipes_alunos                   : [],
                      };

export default function(state = INITIAL_STATE,action){

    switch (action.type) {

        case FETCH_ALL_EQUIPE_TURMA:
           return {
                    all_equipe_turma : (action.payload ? action.payload.data.equipes:[]),
                    nome_turma       : action.payload.data.nome_turma
                 }


        case FETCH_ALL_EQUIPES_ALUNOS:

            return {
                all_equipes_alunos : (action.payload ? action.payload.data:[])
            }

        case FETCH_ALL_EQUIPE_POSTS:

           return {
                    all_equipe_posts  : (action.payload.data ? action.payload.data.posts:[]),
                    nome_equipe       : action.payload.data.equipe,
                    curso             : action.payload.data.curso,
                    turma             : action.payload.data.turma,
                    disciplina_equipe : action.payload.data.disciplina
                  }
       
        case FETCH_ALL_ALUNOS_EQUIPE:

            return {
                     ...state,all_aluno_equipe : (action.payload.data?action.payload.data:[]),
                            dados_turma: action.payload.data.dados_turma,
                            alunos: action.payload.data.alunos
                    }

        case FETCH_ALL_DISCIPLINA_PROFESSOR:
                
            return {
                     ...state,all_disciplina_turma_professor : (action.payload.data?action.payload.data:[]),
                    }
                  
        case FETCH_ALL_COMENTARIOS_POSTS_EQUIPE:
            return { ...state, all_aluno_equipe : (action.payload.data?action.payload.data:[]) }
       
        case FETCH_ALL_ALUNOS_ADICIONAR_EQUIPE:
            return { ...state, all_aluno_adicionar_equipe : (action.payload.data?action.payload.data:[]) }

        case FETH_COMENTATIO_POST_EQUIPE:
            return {...state, all_comentarios_posts_equipe:(action.payload.data?action.payload.data:[])}    
       
        case FETH_ALL_PROFESSOR_EQUIPE:
              return {...state, all_equipe_professor:(action.payload.data?action.payload.data:[])}    

        case FETH_ALL_PROFESSOR_TURMA_DISCIPLLINA:

              return {...state, all_fatch_professor_turma_disciplina:(action.payload.data?action.payload.data:[])}

        case FETH_ALL_EQUIPES_ATIVAS_INATIVAS_PROFESSOR:

             return {...state, all_equipes_ativas_professor   : (action.payload.data.equipes.ativas   ? action.payload.data.equipes.ativas:[]),
                               all_equipes_inativas_professor : (action.payload.data.equipes.inativas ? action.payload.data.equipes.inativas:[]),
                               nome_disciplina:action.payload.data.disciplina }
       
        case ADD_POST_EQUIPE:
            
             const post = {
                                "use_id"              : action.payload.data.usuario.use_id,
                                "use_nome"            : action.payload.data.usuario.use_nome,
                                "use_foto"            : action.payload.data.usuario.use_foto,
                                "use_email"           : action.payload.data.usuario.use_email,
                                "equ_pos_id"          : action.payload.data.post.equ_pos_id,
                                "equ_pos_cod_equipe"  : action.payload.data.post.equ_pos_cod_equipe,
                                "equ_pos_cod_usuario" : action.payload.data.post.equ_pos_cod_usuario,
                                "equ_pos_post"        : action.payload.data.post.equ_pos_post,
                                "equ_pos_tipo"        : action.payload.data.post.equ_pos_tipo,
                                "equ_pos_midia"       : action.payload.data.post.equ_pos_midia,
                                "equ_pos_flag_ativo"  : 1,
                                "created_at"          : action.payload.data.post.created_at,
                                "updated_at"          : action.payload.data.post.updated_at,
                                "num_like"            : 0,
                                "likes"               : false,
                                "like_usuario"        : 0,
                                "qtd_comentarios"     : 0
                            }

             return { ...state,all_equipe_posts: [post,...state.all_equipe_posts] } 

        case ADD_EQUIPE:

            const dados = action.payload.data;
            const lista = state.all_equipes_ativas_professor;

            const add_equipe = lista.concat(dados);

            return { ...state,all_equipes_ativas_professor: add_equipe,...state.all_equipes_ativas_professor }


        case UPDATE_EQUIPE:
                          
            const update_equipe = state.all_equipes_ativas_professor.filter((item) =>{
                if (item.equ_id === action.payload.data.equ_id) {
                    return  item.equ_nome = action.payload.data.equ_nome;
                }else{
                    return item.equ_id;
                }
            }) 
                                                             
            return { ...state, all_equipes_ativas_professor : update_equipe }
   

        case ADD_LIKE_POST_EQUIPE:
         
            const filtro = state.all_equipe_posts.filter((item) =>{
                if (item.equ_pos_id === action.payload.data.id_post) {
                    
                    if (action.payload.data.status>0) {

                       item.num_like = action.payload.data.qtd_likes;
                       return  item.like_usuario = 1;
                       
                    } else {
         
                        item.num_like = action.payload.data.qtd_likes;
                        return  item.like_usuario ="0"; 
                    }
                   
                }else{
                    return item.equ_pos_id;
                }
                
            }) 
                                                                 
            return { ...state, all_equipe_posts : filtro }


        case ADD_POST_COMENTARIO_EQUIPE:

            const response        = action.payload[0].data;
            const qtd_comentarios = action.payload[1].data;
            const comentario      = {
                                    equ_com_pos_id              : response.comentario.equ_com_pos_id,
                                    equ_com_pos_cod_equipe_post : response.comentario.equ_com_pos_cod_equipe_post,
                                    equ_com_pos_cod_usuario     : response.comentario.equ_com_pos_cod_usuario,
                                    equ_com_pos_comentario      : response.comentario.equ_com_pos_comentario,
                                    created_at                  : response.comentario.created_at,
                                    updated_at                  : response.comentario.updated_at,
                                    use_email                   : response.usuario.use_email,
                                    use_foto                    : response.usuario.use_foto,
                                    use_id                      : response.usuario.use_id,
                                    use_login                   : response.usuario.use_login,
                                    use_nome                    : response.usuario.use_nome
                                }

            const filtroQtdComentarioPost =  state.all_equipe_posts.filter((item) =>{
                if (item.equ_pos_id === response.comentario.equ_com_pos_cod_equipe_post) {
                    return  item.qtd_comentarios = qtd_comentarios;
                }else{
                    return item.equ_pos_id;
                }
            });                 

            return { ...state, 
                                all_comentarios_posts_equipe : [comentario,...state.all_comentarios_posts_equipe],
                                all_equipe_posts             : filtroQtdComentarioPost
                     }   

        case FETCH_ALL_TURMA_DISCIPLINA:
            return { ...state, all_equipe_turma : action.payload }
            
        case REMOVER_POST_EQUIPE:
            return { ...state, all_equipe_posts : state.all_equipe_posts.filter(item => item.equ_pos_id !== action.payload) }

        case REMOVER_EQUIPE:
       
           return { ...state, all_equipes_ativas_professor : state.all_equipes_ativas_professor.filter(item => item.equ_id !== action.payload) }

        case REMOVER_ALUNO_EQUIPE:
            console.log(state.all_aluno_equipe);
            return { ...state, alunos : state.alunos.filter(item => item.use_id !== action.payload) }
      
        case REMOVER_COMENTARIO_POST_EQUIPE:

            const dadosComentario    = action.payload[0];
            const filtroRemoveComentarioPost =  state.all_equipe_posts.filter((item) =>{
                if (item.equ_pos_id === dadosComentario.equ_com_pos_cod_equipe_post) {
                    return item.qtd_comentarios = (item.qtd_comentarios===1 ? "0" : item.qtd_comentarios-1);
                  
                }else{
                    return item.equ_pos_id;
                }
            });   

            return { ...state, 
                                all_comentarios_posts_equipe : state.all_comentarios_posts_equipe.filter(item => item.equ_com_pos_id !== dadosComentario.equ_com_pos_id), 
                                all_equipe_posts             : filtroRemoveComentarioPost 
                    }


        case DESATIVAR_EQUIPES:

            console.log(action.payload.data.equipes.inativas);

            return { ...state, all_equipes_ativas_professor : action.payload.data.equipes.ativas,
                               all_equipes_inativas_professor: action.payload.data.equipes.inativas }

        default:
         return state;   

        
    }

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_equipe.js